import React from 'react'
import HeaderComponent from '../WebSite/Header/HeaderComponent'
import FooterComponent from '../WebSite/Footer/FooterComponent'
import AgentForm from '../AgentForm/AgentForm'
import UpdatesBanner from '../UpdatesBanner/UpdatesBanner'

// Main component for Agent page
export default function Agent() {
  return (
    <>
      {/* Header Section */}
      <HeaderComponent />

      {/* Banner Section */}
      <UpdatesBanner
        className="AgentBanner"
        bannerText={[
          <span key="1">Become a GBR Care agent tasked with onboarding agri-retailers/  </span>,
          <br key="2" className="d-lg-block d-none"></br>,
          <span key="3">agro-dealers to facilitate the sale of quality inputs to local farmers</span>,
        ]}
        bannerbodycopy="To apply for a job as an GBR Care, please fill in the form below "
        href="#AgentForm"
        buttonText5="Apply to become Agent"
        DlBtn="true"
        dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.agriminer&pli=1"
        DownloadText="Download App"
      />

      {/* Agent Form Section */}
      <div id="AgentForm">
        <AgentForm usertype="Agent" />
      </div>

      {/* Footer Section */}
      <FooterComponent />
    </>
  );
}

